import { Outlet, useLoaderData } from '@remix-run/react'
import { Sidebar } from '~/design-system/components'
import type { loader } from '~/routes/myaccount'

export default function MyAccountIndex() {
  useLoaderData<typeof loader>()

  return (
    <>
      <Sidebar />
      <Outlet />
    </>
  )
}
